import React from 'react';

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material';
import {
  Control,
  Controller,
  FieldError,
  RegisterOptions,
} from 'react-hook-form';

interface SelectElementProps {
  name: string;
  control: Control<any>;
  rules?: RegisterOptions;
  required?: boolean;
  label?: string;
  options: { value: string; label: string }[];
  placeholder?: string;
}

const SelectElement: React.FC<SelectElementProps & SelectProps> = ({
  name,
  control,
  rules,
  required = false,
  label,
  options,
  placeholder,
  ...selectProps
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field,
        fieldState: { error },
      }: {
        field: any;
        fieldState: { error?: FieldError };
      }) => (
        <FormControl fullWidth size="small" margin="dense" error={!!error}>
          {label && (
            <InputLabel shrink={!!field.value || undefined}>{label}</InputLabel>
          )}
          <Select
            {...field}
            displayEmpty
            variant="outlined"
            label={label}
            {...selectProps}
          >
            {placeholder && (
              <MenuItem value="" disabled>
                {placeholder}
              </MenuItem>
            )}
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {error && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default SelectElement;
